import api from "../../services/admin_api_global";

const BASE = "/admin/expenses";

console.debug("[expenseService] baseURL:", api.defaults.baseURL);
console.debug("[expenseService] BASE path:", BASE);

export const fetchExpenses       = (params) => {
  console.debug("[expenseService] fetchExpenses →", BASE, params);
  return api.get(BASE, { params });
};
export const fetchExpenseSummary = () => {
  console.debug("[expenseService] fetchExpenseSummary →", `${BASE}/summary`);
  return api.get(`${BASE}/summary`);
};
export const createExpense       = (body) => {
  console.debug("[expenseService] createExpense →", BASE, body);
  return api.post(BASE, body);
};
export const updateExpense       = (id, body) => {
  console.debug("[expenseService] updateExpense →", `${BASE}/${id}`, body);
  return api.put(`${BASE}/${id}`, body);
};
export const deleteExpense       = (id) => {
  console.debug("[expenseService] deleteExpense →", `${BASE}/${id}`);
  return api.delete(`${BASE}/${id}`);
};
